module.exports = __webpack_public_path__ + "img/history-nine.f2cb7d3e.png";